import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { injectReportsTranslations } from '@core/reports-contracts';
import {
  DataInterval,
  DetailsBreadcrumbsParams,
  DetailsBreadcrumbsService,
  ReportsComponentTileFilterBreadcrumbSync,
} from '@core/reports-types';
import { formatDateWithInterval } from '@core/reports-ui';

@Injectable()
export class DetailsTrendBreadcrumbsService implements DetailsBreadcrumbsService {
  private i18n = inject(I18nService);
  private reportsTranslations = injectReportsTranslations();

  public getBreadcrumbs({
    breadcrumbsSettings,
    dimensions,
  }: DetailsBreadcrumbsParams): ReportsComponentTileFilterBreadcrumbSync[] {
    const breadcrumbs: ReportsComponentTileFilterBreadcrumbSync[] = [];
    const primaryGroup = this.reportsTranslations.translateGroup(breadcrumbsSettings.primaryGroup);

    if (breadcrumbsSettings.dateFilter) {
      const date = formatDateWithInterval(
        dimensions.primary.name,
        breadcrumbsSettings.dateFilter,
        <DataInterval>breadcrumbsSettings.settings?.interval,
      );

      breadcrumbs.push({
        simple: true,
        bold: true,
        translatedValue: `${date.primary}, ${date.secondary}`,
        hasOverwrites: false,
      });
    }

    if (primaryGroup) {
      const label =
        dimensions.secondary.length > 1
          ? this.i18n.translate('tlr.group_name.other')
          : dimensions.secondary[0].name;

      breadcrumbs.push({
        simple: false,
        translatedGroup: primaryGroup,
        translatedValues: [{ label }],
        hasOverwrites: false,
        invalid: false,
      });
    }

    return breadcrumbs;
  }
}
